import { h, Component } from 'preact';
import * as categories from './categories';

export default function createPixelComponent (...Components) {
	// NOTE: Should we have the class outside of this function and just return an instance instead ? Can pass Components as a prop
	// Not a big issue but feels weird to create a whole new class at every call of this function (in the pixels render)
	return class PixelComponent extends Component {
		constructor(props) {
			super(props);
			this.onCategoriesChange = this.onCategoriesChange.bind(this);
			this.state.categories = [...categories.get()];
		}

		componentDidMount() {
			categories.addChangeListener(this.onCategoriesChange);
		}

		componentWillUnmount() {
			categories.removeChangeListener(this.onCategoriesChange);
		}

		shouldComponentUpdate(nextProps, nextState) {
			return nextState.categories !== this.state.categories || nextProps.children !== this.props.children;
		}

		onCategoriesChange(nextCategories) {
			this.setState({ categories: [...nextCategories] });
		}

		render() {
			let displayedComps = Components.map(data => {
				if (!data) {
					return;
				}
				let [cat, comp] = data;
				if (categories.has(this.state.categories, cat)) {
					return comp;
				}
			}).filter(comp => comp);
			return (
				<div>
					{displayedComps.map(Component => <Component {...this.props} />)}
				</div>
			);
		}
	};
}
